import { render, staticRenderFns } from "./QuotaRecordsView.vue?vue&type=template&id=4a9bb090&scoped=true"
import script from "./QuotaRecordsView.vue?vue&type=script&lang=js"
export * from "./QuotaRecordsView.vue?vue&type=script&lang=js"
import style0 from "./QuotaRecordsView.vue?vue&type=style&index=0&id=4a9bb090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e7c46a58a2b84365ed6c46ff010356d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bb090",
  null
  
)

export default component.exports